import React, { useEffect } from "react";
import {
	Grid,
	IconButton,
	InputAdornment,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useApi } from "../../../../../../common/hooks";
import { LicenceManagementService } from "../../../../../../api";
import { setUpdateLicenceManagement } from "../../../../../../common/slice";
import HeadCell from "../../../table/HeadCell";
import { CustomButton, CustomTextField, icon, IconComponent } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import style from "./ListProjectBU.module.css";

export default function ListProjectBU() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [searchValue, setValueSearch] = React.useState(licenceManagementStore?.search?.searchProjectBu);

	const { call: getListProjectByBuAndUser } = useApi(LicenceManagementService.getListProjectByBuAndUser);
	const { call: updateUserStatusInProject } = useApi(LicenceManagementService.updateUserStatusInProject);
	const dispatch = useDispatch();
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [pageDataTable, setPageDataTable] = React.useState(0);
	const preparePayload = () => {
		let payload = {};

		payload = {
			sort: "name",
			direction: "ASC",
			userId: licenceManagementStore.selectedUser.id,
			companyId: licenceManagementStore.companySelected.id,
			projectName: licenceManagementStore?.search?.searchProjectBu,
		};

		return payload;
	};
	const getBodyTable = (params) => {
		getListProjectByBuAndUser(params)
			.then((data) => {
				dispatch(setUpdateLicenceManagement({ listProjectByCompanyAndUser: data }));
			})
			.catch((err) => console.error(err));
	};

	const fetchApi = () => {
		const payload = preparePayload();
		const params = {
			payload,
			page: pageDataTable,
			limit: rowsPerPage,
		};
		getBodyTable(params);
	};

	useEffect(() => {
		fetchApi();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [licenceManagementStore.companySelected?.companyName, licenceManagementStore.search?.searchProjectBu]);
	const handleChangePage = (event, newPage) => {
		setPageDataTable(newPage);

		const payload = preparePayload();
		const params = {
			page: newPage,
			limit: rowsPerPage,

			payload,
		};

		getBodyTable(params);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPageDataTable(0);

		const payload = preparePayload();
		const params = { page: 0, limit: event.target.value, payload };
		getBodyTable(params);
	};
	const handelSearchInput = (e) => {
		setValueSearch(e.target.value);
		if (e.target.value === "") {
			dispatch(setUpdateLicenceManagement({ searchCompaniesByUser: "" }));
		}
	};
	const handelSearchInputProps = () => {
		dispatch(
			setUpdateLicenceManagement({ search: { ...licenceManagementStore?.search, searchProjectBu: searchValue } })
		);
	};

	const handelUpdateRoleUserInCompanyByProject = (role, projectId) => {
		updateUserStatusInProject({
			userId: licenceManagementStore.selectedUser.id,
			companyId: licenceManagementStore.companySelected.id,
			projectId,
			payload: role === "ACTIVE" ? "BLOCKED" : "ACTIVE",
		})
			.then(() => {
				fetchApi();
			})
			.catch(console.error);
	};
	return (
		<Grid container bgcolor="white" p={2}>
			<Grid item md={12}>
				<CustomTextField
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton onClick={handelSearchInputProps}>
									<IconComponent color="var(--grey-400)" icon={icon.faSearch} />
								</IconButton>
							</InputAdornment>
						),
					}}
					placeholder={translate("common:licence-management.input.search-contract")}
					size="small"
					value={searchValue}
					variant="outlined"
					onChange={(e) => {
						if (e.target.value === "") {
							dispatch(
								setUpdateLicenceManagement({
									search: { ...licenceManagementStore?.search, searchProjectBu: "" },
								})
							);
						}
						handelSearchInput(e);
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							handelSearchInputProps();
						}
					}}
				/>
			</Grid>

			<Grid item md={12}>
				<div className={style.tableContainer}>
					<Table className={style.table}>
						<TableHead className={style.tableHead}>
							<HeadCell
								hiddenSort
								cell={{
									name: translate("common:licence-management.list-project-bu.label.contract-name"),
								}}
							/>
							<HeadCell
								hiddenSort
								cell={{
									name: translate("common:licence-management.list-project-bu.label.access"),
								}}
							/>
							<HeadCell
								hiddenSort
								cell={{
									name: "",
								}}
								className={style.cellAction}
							/>
						</TableHead>
						<TableBody>
							{licenceManagementStore?.listProjectByCompanyAndUser?.contents?.map((project) => (
								<TableRow className={project?.status !== "ACTIVE" ? style.blockedCell : ""}>
									<TableCell>
										{project?.name}{" "}
										{project?.status !== "ACTIVE" &&
											` (${translate("common:licence-management.status.archived")})`}
									</TableCell>

									<TableCell>
										{project?.userStatus === "ACTIVE"
											? translate("common:licence-management.status.allowed")
											: translate("common:licence-management.status.unAllowed")}
									</TableCell>
									<TableCell>
										{" "}
										<CustomButton
											fullWidth
											color={project?.userStatus === "ACTIVE" ? "secondary" : "primary"}
											data-testid={`contract.status.${project?.name}`}
											startIcon={project?.userStatus === "ACTIVE" ? icon.faLockOpen : icon.faLock}
											variant="outlined"
											onClick={() =>
												handelUpdateRoleUserInCompanyByProject(project?.userStatus, project.id)
											}
										>
											{project?.userStatus === "ACTIVE"
												? translate("common:licence-management.user.btn-not-allowed")
												: translate("common:licence-management.user.btn-allowed")}
										</CustomButton>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
				<TablePagination
					component="div"
					count={licenceManagementStore?.listProjectByCompanyAndUser?.totalElements}
					labelRowsPerPage={translate("common:pagination.row-per-page")}
					page={pageDataTable}
					rowsPerPage={rowsPerPage}
					rowsPerPageOptions={[25, 50, 75]}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Grid>
		</Grid>
	);
}
